module.exports = __webpack_public_path__ + "img/career-0.fd3e6ef3.jpg";